import {NgModule} from '@angular/core';

// Import components from this module
import {SafePipe} from './safe.pipe';

@NgModule({
    declarations: [     // Components declared in this module
        SafePipe,
    ],
    imports: [
    ],
    exports: [      // Allow access from other modules to these components
        SafePipe
    ],
    providers: [
    ]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// /app/src/pipes/pipes.module.ts